<template>
  <div class="floor-banner">
    <h3>订单提交成功！订单号: {{ orderInfo.orderNum }}</h3>
    <img class="icon-success" src="https://www.huishoubao.com/static/pc/1001/img/logo-order-success.jpg">
    <p class="money-tip">
      <span class="money-tip__label">估价金额：</span>
      <span class="money-tip__num">{{ orderInfo.totalPrice | fen2yuan }}</span>
    </p>
    <p class="wallet-tip" v-if="isSF">
      <span>估价金额已经打入到您的待入账金额</span>
      <router-link class="link" to="/Account/Wallet">点击查看详细 ></router-link>
    </p>
    <router-link class="button-product" to="/products">继续回收</router-link>
  </div>
</template>

<script>
export default {
  props: {
    isSM: Boolean,
    isSF: Boolean,
    orderInfo: Object
  }
};
</script>

<style scoped>
.floor-banner {
  position: relative;
  height: 156px;
  padding-left: 110px;
  padding-right: 40px;
  margin-top: 20px;
  background-color: #fff;
  h3 {
    font-size: 16px;
    line-height: 28px;
    font-weight: 400;
    padding-top: 45px;
  }
  .icon-success {
    position: absolute;
    top: 46px;
    left: 32px;
  }
  .money-tip {
    margin-top: 5px;
    font-weight: bold;
    &__label {
      font-size: 16px;
      color: #666;
    }
    &__num {
      font-size: 28px;
      color: #ff5f43;
    }
  }
  .button-product {
    display: block;
    width: 260px;
    height: 50px;
    font-size: 18px;
    line-height: 50px;
    position: absolute;
    top: 56px;
    right: 40px;
    color: #ffffff;
    text-align: center;
    background: #ff5f43;
    border-radius: 4px;
    &:hover {
      background: #ff7860;
    }
  }
}

.wallet-tip {
  margin-top: 13px;
  color: #999;
  .link {
    margin-left: 10px;
    color: #3b9bff;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/orderResult/floor-banner.vue